'use client'

import { useCallback } from 'react'
import { useRouter, useSearchParams } from 'next/navigation'

export const usePaginationUrl = () => {
  const router = useRouter()
  const searchParams = useSearchParams()

  const page = Math.max(1, Number(searchParams?.get('page') || 1))

  const setPage = useCallback(
    (nextPage: number) => {
      const params = new URLSearchParams(searchParams?.toString())

      if (nextPage <= 1) {
        params.delete('page')
      } else {
        params.set('page', String(nextPage))
      }

      router.push(`?${params.toString()}`, { scroll: true })
    },
    [router, searchParams]
  )

  return { page, setPage }
}
